export { default as EditAccount } from './account/edit_account';
export { default as UserAccount } from './account/user_account';
export { default as AddProduct } from './admin/add_product';
export { default as Dashboard } from './admin/dashboard';
export { default as EditProduct } from './admin/edit_product';
export { default as Products } from './admin/products';
export { default as ForgotPassword } from './auth/forgot_password';
export { default as SignIn } from './auth/signin';
export { default as SignUp } from './auth/signup';
export { default as CheckOutStep1 } from './checkout/step1';
export { default as CheckOutStep2 } from './checkout/step2';
export { default as CheckOutStep3 } from './checkout/step3';
export { default as PageNotFound } from './error/PageNotFound';
export { default as FeaturedProducts } from './featured';
export { default as Home } from './home';
export { default as RecommendedProducts } from './recommended';
export { default as Search } from './search';
export { default as Shop } from './shop';
export { default as ViewProduct } from './view_product';

